<template>
  <button class="button btn-back is-primary-ghost-small" @click="$emit('click')">
    <left-arrow v-if="showArrow"></left-arrow>
    <span>{{ backButtonText }}</span>
  </button>
</template>

<script>

import LeftArrow from './LeftArrow';

export default {
  props: {
    text: {
      type: String,
      required: false
    },
    showArrow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    backButtonText() {
      return this.text ? this.text : this.$gettext('Back');
    }
  },
  components: {
    LeftArrow
  }
};
</script>

<style lang="scss" scoped>
.btn-back {
  background: var(--light-light-gray);

  svg {
    position: relative;
    top: -1px;
  }

  span {
    padding-left: 5px;
  }
}
</style>
